import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import LocaleHelper from 'lib/utility/locale_helper';
import { AvailableLanguagesField } from '@everfi/reactifi/src/components/Form/AvailableLanguagesField';

export default class LanguageFieldWrapper extends React.Component {
  render() {
    return (
      <div>
        <FormControl type="hidden" name="form_locale" value={LocaleHelper.formLocale} />

        <AvailableLanguagesField
          activeLanguage={LocaleHelper.activeLanguage}
          languages={LocaleHelper.supportedLanguages}
          onLanguageChange={LocaleHelper.setFormLocale}
        />
      </div>
    );
  }
}
